module.exports = __webpack_public_path__ + "static/media/ni.26df812a.png";